export const ProperytUriValidator = (propValue: string) => {
    //const expression = new RegExp("/^(?:(?:https?|ftp)://)?(?:(?!(?:10|127)(?:.d{1,3}){3})(?!(?:169.254|192.168)(?:.d{1,3}){2})(?!172.(?:1[6-9]|2d|3[0-1])(?:.d{1,3}){2})(?:[1-9]d?|1dd|2[01]d|22[0-3])(?:.(?:1?d{1,2}|2[0-4]d|25[0-5])){2}(?:.(?:[1-9]d?|1dd|2[0-4]d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:.(?:[a-z\u00a1-\uffff]{2,})))(?::d{2,5})?(?:/S*)?$/");
    const expression = new RegExp("^.*/.*")
    if ( propValue !== undefined && propValue.length > 3) {
      if ( expression.test(propValue)) return true;
    }
    return false;
}   

export const PropertyJsonValidator = (propValue: string) => {
    if ( propValue === undefined || propValue === null || propValue.length <= 0) {
      return true;
    }
    try{
      JSON.parse(propValue)
      return true;
    } catch( e) {
      return false;
    }
  }     

 export const PropertySimpleNameValidator = (propValue: string) => {
    if ( propValue !== undefined && propValue.length > 3) {
      return true;
    }
    return false;
  }